<template>
<div class="page-container container-fixed">

    <div v-if="game" class="row no-gutters justify-content-center text-center">
        <div class="col-12">
            <div class="display-block">
  
                <div class="row no-gutters mb-4">
                    <div class="col-12 text-center">
                        <div v-if="!game.isComplete" class="main-header">
                            {{ 'REWARD_POOL' | translate }}: {{ fromWei(game.rewardPool) }} NAS
                        </div> 
                        <div v-else-if="game.isComplete && game.winner" class="main-header">
                            <div class="mb-2">
                                {{ 'CONGRATS_TO_WINNER' | translate }} {{ fromWei(game.rewardPool) }} NAS {{ 'REWARD' | translate }}
                            </div>
                            <div class="d-none d-sm-block">
                                {{ game.winner }}
                            </div>
                            <div class="d-block d-sm-none">
                                {{ game.winner.substr(game.winner.length-4, 4) }}
                            </div>
                        </div>                         
                    </div>
                </div>  

                <div class="row mb-2">
                    <div class="col-item col-4 col-sm-2">
                        <header>
                            {{ 'OWNER' | translate }}
                        </header>
                        <div>
                            {{ game.owner.substr(game.owner.length-4, 4) }}
                        </div>
                    </div>
                    <div class="col-item col-4 col-sm-2">
                        <header>
                            {{ 'GRID_SIZE' | translate }}
                        </header>
                        <div>
                            {{ game.gridSize }}
                        </div>
                    </div>
                    <div class="col-item col-4 col-sm-2">
                        <header>
                            {{ 'STATUS' | translate }}
                        </header>
                        <div>
                            {{ game.isComplete ? 'Closed' : 'Open' }}
                        </div>
                    </div>

                    <div class="col-item col-4 col-sm-2">
                        <header>
                            {{ 'PLAYERS' | translate }}
                        </header>
                        <div>
                            {{ Object.keys(game.players).length }}
                        </div>
                    </div>
                    <div class="col-item col-4 col-sm-2">
                        <header>
                            {{ 'PRICE_TO_PLAY' | translate }}
                        </header>
                        <div>
                            {{ game.price }} NAS
                        </div>
                    </div>
                    <div class="col-item col-4 col-sm-2">
                        <header>
                            {{ 'COMPLETED' | translate }}
                        </header>
                        <div>
                            {{ Math.round(game.blocksPlayed / game.gridSize * 100) }} %
                        </div>
                    </div>
                </div>      
            </div>
        </div>
    </div>

    <div v-if="game" class="row no-gutters justify-content-center text-center">
        <div class="col-12">
            <div class="display-block pt-4 guess-block">  
                <header>
                    Players
                </header>
                <div class="mt-2 mb-3">
                    <span v-for="(player, key, index) in game.players" :key="index">
                        <span class="text-lg">{{ key.substr(key.length-4, 4) }}</span>
                        <span class="muted" v-if="Object.keys(game.players).length > index+1">VS</span>
                    </span>
                </div>
                <div class="action-container mb-3">
                    <button @click="showLog = true" v-if="!showLog && !pendingTransaction" class="btn btn-primary">
                        {{ "SHOW_STATS" | translate }}
                    </button>
                    <button @click="showLog = false" v-else-if="showLog && !pendingTransaction" class="btn btn-primary">
                        {{ "HIDE_STATS" | translate }}
                    </button>
                    <button v-else disabled class="btn btn-secondary">
                        {{ 'PLEASE_WAIT' | translate }}
                    </button>
                </div>       
                <div v-if="showLog" class="guesslog-container mb-3">
                    <b-button-group class="translation-btn mb-3" size="sm">
                        <b-button :class="{ selected: statSection == 'boardStats' }" @click="statSection = 'boardStats'">Board Stats</b-button>
                        <b-button :class="{ selected: statSection == 'turnOrder' }" @click="statSection = 'turnOrder'">Turn Order</b-button>
                    </b-button-group>   

                    <div v-if="statSection == 'turnOrder'" v-for="(turn, key, index) in game.turnOrder" :key="index">
                        {{ index + 1 }} - {{ turn }}
                    </div>

                    <div v-if="statSection == 'boardStats'" v-for="(count, key) in warLogic(game).blockDominance" :key="key">
                        {{ key }} - {{ 'OWNS' | translate }} - {{ count }} {{ 'GRID_POSITIONS' | translate }}
                    </div>

                    <div class="mt-3 sub">
                        * the winner of a tied game is chosen by a random coin toss
                    </div>
                </div>           
            </div>
        </div>     
    </div>

    <div v-if="game && !game.isComplete" class="row no-gutters justify-content-center sticky-top text-center">
        <div class="col-12">
            <div class="display-block display-blockheads pt-4">
                <header class="mb-3">      
                    {{ 'SELECTION_HELP' | translate }}
                </header>
                <div class="row justify-content-center no-gutters text-center mb-3">
                    
                    <div v-for="(blockHead, index) in game.gridPieces" 
                        :key="index" 
                        @click="selectBlockHead(blockHead)" 
                        :class="{ selected: selectedBlockHead && blockHead.id == selectedBlockHead.id, disabled: checkUserSelection(blockHead) }" 
                        class="col-1 blockhead-container text-center">

                        <BlockHead :blockhead="blockHead" />
                    </div>
                    <div v-if="!pendingTransaction" class="col-md-12 text-center pt-3">
                        <button v-if="address && allowPlayer()" @click="playGame" class="btn btn-primary">
                            {{ 'SUBMIT_SELECTION' | translate }}
                        </button>
                        <button v-else class="btn btn-secondary">
                            {{ 'PLAYER_LIMIT_REACHED' | translate }}
                        </button>
                    </div>
                    <div v-else class="col-md-12 text-center pt-3"> 
                        <div class="transaction-loader">
                            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                            <sub>{{ 'PENDING_TRANSACTION' | translate }}</sub>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div> 
    </div> 

    <div v-if="game" class="row no-gutters justify-content-center the-grid mt-4">
        <div v-for="(item, index) in game.gridSize" :key="index" class="col-3">
            <div v-if="!game.blocks[item]" @click="selectGridPoint(item)" :class="{ selected: selectedGridPoint == item}" class="grid-item block-container">                
                <div v-if="selectedGridPoint != item" class="inner-content">
                    {{ item }}
                </div>
                <BlockHead v-else-if="selectedBlockHead" :blockhead="selectedBlockHead" />
                <div v-else class="inner-content">
                    {{ 'SELECT_BLOCKHEAD' | translate }}
                </div>
            </div>
            <div v-else class="block-container"> 
                <span class="address-tag">
                    {{ game.blocks[item].owner.substr(game.blocks[item].owner.length-4, 4) }}
                </span>         
                <BlockHead :blockhead="game.blocks[item].blockHead" :warLogic="warLogic(game).results[item]" />
            </div>
        </div>
    </div>

    <div v-if="!game" class="row no-gutters justify-content-center">
        <div class="col-md-12 text-center">
            <div class="generic-container">
                {{ 'NO_GAME' | translate }}
            </div>
        </div>
    </div>

</div>

</template>

<script>
import { mapGetters } from "vuex";
import { warLogic } from "../util/warLogic";
import BlockHead from "../components/BlockHead";
import { contractAddress, nebPay, neb } from "../util/nebulas";

export default {
    name: "Block",
    components: { BlockHead },
    computed: {
        ...mapGetters({
            game: 'getGame',
            games: 'getGames',
            address: 'getAddress',
            userBlockHeads: 'getUserBlockHeads',
            pendingTransaction: 'getPendingTransaction'
        }),
        randomNumber () {
            return Math.floor(Math.random() * 10);
        }
    },
    created () {

        const id = this.$route.params.id;

        if (this.games.length > 0) {
            
            this.$store.commit('setGame', { id });

        } else {

            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'setGames') {
                    this.$store.commit('setGame', { id });
                }
            });
            
        }

    },
    data() {
        return {
            showLog: true,
            selectedGridPoint: null,
            selectedBlockHead: null,
            statSection: 'boardStats'
        };
    },
    methods: {
        openModal () {
            this.$root.$emit('bv::show::modal','modal-grid');
        },

        warLogic () {
            const returnObject = warLogic(this.game);

            return { 
                results: returnObject.results,
                blockDominance: returnObject.blockDominance
            };
        },

        checkUserSelection (blockHead) {

            if (!this.address) return false;
            if (!this.game.players[this.address]) return false;
            if (!this.game.players[this.address].pieces[blockHead.id]) return false;

            return true;

        },

        allowPlayer () {

            let isPlayer = false;
            for (let index in this.game.players) {
                if (index == this.address) {
                    isPlayer = true;
                }
            }

            if (!isPlayer && Object.keys(this.game.players).length < 2) {
                isPlayer = true;
            }

            return isPlayer;

        },

        selectGridPoint (gridPoint) {
            this.selectedGridPoint = gridPoint;
        },

        selectBlockHead (blockHead) {

            if (this.checkUserSelection(blockHead)) {

                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'You have already placed this piece!'
                });
                return;
            }

            this.selectedBlockHead = blockHead
        },

        formatDate (date) {
            return this.$moment(new Date(date)).format('MM/DD/YYYY');
        },

        goToRoute (name) {
            this.$router.push(name);
        },
        
        fromWei (value) {
            return neb.fromBasic(value, "nas").toNumber();
        },
        
        playGame () {
            const game = this.game;
            const gridId = this.selectedGridPoint;
            const blockHead = this.selectedBlockHead;

            if (game.isComplete) {
                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'This game is over!'
                });

                return;
            }

            if (!blockHead) {
                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'Please select a blockhead!'
                });

                return;
            }

            if (!gridId) {
                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'Please select a grid point'
                });

                return;
            }

            if (!this.allowPlayer()) {

                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'Only 2 players allowed! Please check address.'
                });

                return;

            }

            const price = game.price;
            const payload = { gameId: game.id, gridId, blockHeadId: blockHead.id, price };

            this.$store.commit('updatePendingTransaction', { status: true });
            this.$store.dispatch('playGame', payload).then((response) => {

                if (response.message == 'success') {

                    this.$notify({
                        group: "app",
                        title: "Success!",
                        text: 'You have placed a blockhead, please see results below!'
                    });

                } else if (response.message == 'error') {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was an error with your transaction'
                    });

                } else {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was a problem loading your data, please refresh'
                    });

                }

                this.$store.commit('updatePendingTransaction', { status: false });

                // Update selection
                this.selectedGridPoint = null;
                this.selectedBlockHead = null;

            });

        }
    }
};
</script>

<style scoped lang="less">
@import "../assets/less/app.less";
@bgAccentColor: #3F4353;

.generic-container {
    padding: 40px;
    background: @bgAccentColor;
}

.page-container {
    padding: 20px;
    color: #fff;

    .muted {
        margin: 0 10px 0 5px;
        font-size: 13px;
        color: #96999C; 
        display: inline-block;
    }

    .sub {
        font-size: 13px;
        color: #96999C; 
    }

    .text-lg {
        font-size: 24px;
    }

    .the-grid .block-container {
        position: relative;

        .address-tag {
            border-bottom: 1px solid #3C3F44;
            border-right: 1px solid #3C3F44;
            background: #fff;
            padding: 2px 7px;
            font-size: 13px;
            position: absolute;
            color: #3C3F44;
            top: 3px; left: 2px;
            z-index: 2;
        }
        
        .blockhead-item {
            height: 260px;
            padding-top: 60px;
        }
    }

    .display-block {
        background: @bgAccentColor;
        padding-bottom: 5px;

        .main-header {
            padding: 25px;
            font-size: 24px;
            margin-bottom: 10px;
            border-bottom: 3px solid #222532;
        }

        header {
            color: #96999C; 
        }

        .col-item {
            margin-bottom: 20px;
        }

        &.guess-block {
            border-top: 3px solid #222532;
        }

        &.display-blockheads {
            border-top: 3px solid #222532;
            border-bottom: 3px solid #222532;

            .disabled .blockhead-item {
                opacity: 0.2;
            }
        }
    }

    .grid-item {
        font-size: 24px;
        position: relative;
        border: 2px solid #212432;
        background: @bgAccentColor;
        text-align: center;
        cursor: pointer;
        color: #ccc;
        height: 265px;

        .inner-content {
            padding-top: 110px;
        }

        &:hover {
            color: #3c3f44;
            background: #efefef;
        }

        &.guessed {
            cursor: default;
            color: #efefef;
            background-color: darkgray;
            background-image: url(/static/grunge-x.png);
            background-size: auto 100%;
            background-repeat: no-repeat;
            background-position: center center;

            .number-item {
                color: #000;
            }
        }

        &.winner {
            background: #83A485;
        }

        &.selected {
            border: 2px solid #efefef;
        }

        .grid-item-info {
            font-size: 13px;
        }

        .number-item {
            border-radius: 50%;
            padding: 7px;
            background: #efefef;
            position: absolute;
            top: 10px; left: 10px;
            height: 50px;
            width: 50px;
        }
    }

}


// Tablet device
@media only screen and (max-width: 768px) {
    body {}
}

// Phone device
@media only screen and (max-width: 480px) {
     body {}
}
</style>



// WEBPACK FOOTER //
// src/views/Game.vue